<div ngbDropdownMenu class="snippet-menu">
  <div class="align-items-stretch d-flex flex-column">
    <div class="filter-container w-100" id="snippet-form-filter">
      <form [formGroup]="filterForm" class="d-flex flex-column align-items-center p-2">
        <div class="d-flex w-100">
          <div
            ngbDropdown
            display="dynamic"
            placement="bottom-end"
            class="d-inline-block flex-grow-1 w-100 dropdown mb-2">
            <button
              class="btn btn-outline-primary btn-styleless dropdown-toggle w-100 fs-7"
              id="dropdownMenu"
              ngbDropdownToggle>
              Filters
            </button>

            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
              <div class="form-check form-switch">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="filterThisForm"
                  id="filterThisForm"
                  formControlName="filterThisForm"
                  (change)="onOnlyFormChanged($event)" />
                <label class="form-check-label" for="filterThisForm">Only Document Specific</label>
              </div>

              <div class="form-check form-switch">
                <input
                  type="checkbox"
                  name="filterPracticeArea"
                  class="form-check-input"
                  id="filterPracticeArea"
                  formControlName="filterPracticeArea"
                  (change)="onAllForPracticeAreaChanged($event)" />
                <label class="form-check-label" for="filterPracticeArea">All Snippets for active Practice Area</label>
              </div>

              <div class="form-check form-switch">
                <input
                  type="checkbox"
                  name="firmLevel"
                  class="form-check-input"
                  id="firmLevel"
                  formControlName="firmLevel"
                  (change)="onFirmLevelChanged($event)" />
                <label class="form-check-label" for="firmLevel">Include Firm Wide Snippets</label>
              </div>

              <div class="form-check form-switch">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="filterGeneralSnippets"
                  formControlName="filterGeneralSnippets"
                  (change)="onGeneralSnippetsChanged($event)" />
                <label
                  class="form-check-label"
                  ngbPopover="Include General Snippets"
                  triggers="hover"
                  container="body"
                  [openDelay]="500"
                  for="filterGeneralSnippets">
                  Include Generic Snippets
                </label>
              </div>
            </div>
          </div>
          <button type="button" class="btn-refresh" aria-label="Refresh" (click)="refreshSnippets(true)">
            <i class="bi bi-arrow-clockwise"></i>
          </button>
          <button type="button" class="btn-close" aria-label="Close" (click)="menuInstance.close()"></button>
        </div>
        <input
          class="form-control p-2"
          type="text"
          placeholder="Start typing to filter the list"
          (input)="onFilterTextChanged($event)" />

        <!-- <div>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="filterOnlyMine"
              name="filterOnlyMine"
              (change)="onOnlyMineChanged($event)" />
            <label class="form-check-label" for="filterOnlyMine">Available To Everyone In My Firm</label>
          </div>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="filterOnlyTemplate"
              name="filterOnlyTemplate"
              (change)="onOnlyActiveFormChanged($event)" />
            <label class="form-check-label" for="filterOnlyTemplate">Only Active Form</label>
          </div>
        </div> -->
      </form>
    </div>
    <div *ngIf="filteredSnippets$ | async as snippets" id="snippet-list">
      <div
        *ngFor="let snippet of snippets; let idx = index"
        tabindex="0"
        class="card squiggle m-1 mb-2"
        (click)="onSnippetClick(snippet)">
        <div class="squiggle-container">
          <div class="card-header d-flex justify-content-between">
            <div
              class="text-truncate pe-1"
              triggers="hover"
              container="body"
              [openDelay]="500"
              [ngbPopover]="snippet.snippetTitle">
              <span [innerHTML]="snippet.snippetTitle | highlighter : filterText | sanitizeHtml"></span>
            </div>
            <div class="btn-group toolbar">
              <ng-template #popoverContent>
                <div
                  [innerHTML]="getFormattedNote(snippet.snippetNote) | highlighter : filterText | sanitizeHtml"></div>
              </ng-template>
              <button
                type="button"
                class="btn btn-outline-warning btn-sm text-warning-emphasis"
                [ngClass]="{ 'btn-danger': containsText(snippet.snippetNote, filterText) }"
                *ngIf="snippet.snippetNote"
                triggers="hover"
                container="body"
                placement="bottom"
                [openDelay]="500"
                (click)="infoSnippetClick(snippet, $event)"
                [ngbPopover]="popoverContent">
                <i class="bi bi-sticky"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-warning btn-sm text-warning-emphasis"
                title="Copy Snippet"
                (click)="copySnippetClick(snippet, $event)">
                <i class="bi bi-copy"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-warning btn-sm text-warning-emphasis"
                title="edit Snippet"
                (click)="editSnippetClick(snippet, $event)">
                <i class="bi bi-pencil"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger btn-sm text-danger"
                title="Delete Snippet"
                (click)="deleteSnippetClick(snippet, $event)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
          <div class="card-body overflow-y-auto fs-8">
            <div [innerHTML]="snippet.snippetBody | highlighter : filterText | sanitizeHtml"></div>
          </div>
          <div class="card-footer d-flex justify-content-between fs-9">
            <div triggers="hover" [openDelay]="500" container="body" [ngbPopover]="snippet.name">
              {{ snippet.initials }}
            </div>
            <div>
              {{ snippet.dateLastModified | date : 'short' }}
            </div>
            <div>
              {{ snippet.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
